import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        position: 'absolute', // position the backdrop absolutely to cover the entire viewport
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backdropFilter: 'blur(2px)', // apply the blur effect to the backdrop
        backgroundColor: 'rgba(217, 217, 217, 0.5)',
        width: '100%',
    },
    basicWidgets: {
        flex: 1,
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 'auto',
        padding: theme.spacing(2),
        '& Button': {
            textTransform: 'none',
            '& span': {
                fontSize: theme.spacing(2),
            },
        },
    },
    chartWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: theme.spacing(10),
        height: theme.spacing(10),
        cursor: 'pointer',
        border: `1px solid ${theme.palette.primary[800]}`,
        borderRadius: theme.dimensions.borderRadiusInput,
        padding: theme.spacing(1),

        '&:hover': {
            boxShadow: '0px 4px 2px rgba(0, 0, 0, 0.2)',
        },
        '& svg': {
            height: '80%',
            width: '80%',
        },
        '& img': {
            height: '100%',
            width: '100%',
        },
    },
    currentSelection: {
        border: `1px solid ${theme.palette.secondary.main}`,

        '& svg': {
            color: theme.palette.secondary.main,
        },
    },
    dialogWrapper: {
        width: '35%',

        '& .MuiDialogContent-root': {
            display: 'flex',
            alignItems: 'center',
        },
    },
    dialogInnerWrapper: {
        minHeight: theme.spacing(63),
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        background: theme.palette.neutral.main,
    },
    editor: {
        display: 'flex',
        gap: theme.spacing(5),
        flexWrap: 'wrap',
        maxWidth: '100%',
        flexDirection: 'row',
        backgroundColor: theme.palette.neutral.main,
        width: '100%',
    },
    '& .MuiDialog-root': {
        border: `2px solid ${theme.palette.secondary.main}`,
        width: '100%',
    },
    outerWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    settingsLabel: {
        fontSize: theme.spacing(3),
    },
    statistics: {
        flex: 1,
    },
    tooltip: {
        display: 'flex',
        flexWrap: 'nowrap',
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.size.m,
        margin: `${theme.spacing(1.5, 0)} !important`,

        '& .MuiTooltip-arrow': {
            '&:before': {
                background: theme.palette.neutral[100],
            },
        },
    },
    widgetTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: theme.typography.size.l,
        fontWeight: theme.typography.fontWeightBold,

        '& svg': {
            color: theme.palette.secondary.main,
        },
    },
    widgetWrapper: {
        height: '213px',
    },
}));

export default useStyles;
